import createSetGiftCardPaymentVar from './setGiftCardPayment';
import { giftCardPaymentVar } from '../reactiveVariables';

const setGiftCardPayment = createSetGiftCardPaymentVar(giftCardPaymentVar);

export default setGiftCardPayment;
